import { CheckOutlined } from '@ant-design/icons'
import getClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import './verticalStepper.less'

const VerticalStepper = ({ steps, activeStep, onStepClick }) => (
  <div className="vertical-stepper">
    {steps.map((step, index) => {
      const isCompleted = index < activeStep
      const isActive = index === activeStep
      const isLast = index === steps.length - 1

      return (
        <div
          key={step.key}
          onClick={() => onStepClick && onStepClick(index)}
          role={onStepClick ? 'button' : undefined}
          tabIndex={onStepClick ? 0 : undefined}
          className={getClassNames('vertical-stepper__step', {
            'vertical-stepper__step--clickable': !!onStepClick,
          })}
          onKeyDown={e =>
            onStepClick && e.key === 'Enter' && onStepClick(index)
          }
        >
          <div className="vertical-stepper__icon-column">
            <div
              className={getClassNames('vertical-stepper__icon', {
                'vertical-stepper__icon--active': isActive,
                'vertical-stepper__icon--completed': isCompleted,
              })}
            >
              {isCompleted && (
                <CheckOutlined className="vertical-stepper__check" />
              )}
            </div>
            {!isLast && <div className="vertical-stepper__line" />}
          </div>
          <div className="vertical-stepper__label-column">
            <span
              className={getClassNames('vertical-stepper__label', {
                'vertical-stepper__label--active': isActive,
                'vertical-stepper__label--completed': isCompleted,
              })}
            >
              {step.label}
            </span>
          </div>
        </div>
      )
    })}
  </div>
)

VerticalStepper.defaultProps = {
  activeStep: 0,
  onStepClick: undefined,
}

VerticalStepper.propTypes = {
  activeStep: PropTypes.number,
  onStepClick: PropTypes.func,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default VerticalStepper
